const eosAPI = 'https://api.eosfrontier.space/'
const eos = 'https://www.eosfrontier.space/'
const s_eos = '.eosfrontier.space/'
const ht = 'https://'
const sheet = 'https://docs.google.com/spreadsheets/d/'
const form = 'https://docs.google.com/forms/d/e/'
const folder = 'https://drive.google.com/embeddedfolderview'

export const environment = {
  production: true,
  API: {
    ORTHANC: `${eosAPI}orthanc/v2/`,
    TOKEN: `mJ67eW33dfDdz9HGRP2U`,
    TIME: `${eosAPI}watchtower/time`,
    ID: `/assets/idandgroups.php`,
  },
  URL: {
    VOTEAQUILA: `${ht}voteaquila${s_eos}`,
    LOGIN: `${eos}return-to-dashboard`,
    TALON: `${ht}talon${s_eos}`,
    AV: `${ht}av${s_eos}`,
    BIC: `${eos}bic`,
    BMS: `${sheet}1zmblnRPwSAOMcPscwfgfkjx-CqWLg5GklXqPjmoivb4/preview?usp=embed_googleplus`,
    BEACON: `${ht}beacon${s_eos}`,
    BET: `${form}1FAIpQLSdcULjrZ0_HuOuIoTmVNc8TxcT_umeQni8j52UmfZv2o1u7Uw/viewform`,
    BSE: `${form}1FAIpQLSf9pEf5oXJSmgMasLYgum8-Z_S5lRbMsJIttV8IOFtnAYeJjQ/viewform`,
    CIC: `${ht}cic${s_eos}`,
    CORP: `${sheet}14APz8lfAVarJRf_Wgg0YCVAsxpBGADAdhfT2sVtPmEQ/view?rm=minimal#gid=0`,
    CUSTOMS: `${eos}eos_douane/`,
    AIT: `${eos}ems`,
    ROSTER: `${eos}roster`,
    MEDICORUM: `${eos}medicorum`,
    SURGERY: `${sheet}1lg_oiERaR31BnudEzOg08_sQ-4_YZSLCCwsudgdmfo8/view?rm=minimal#gid=0`,
    SCB: `${eos}eos_bank/`,
    RESEARCH: `${folder}?id=0B_bdsbsVGdzpZDkzQy1YQWdkdWc#list`,
    MAIL: `${ht}mail${s_eos}`,
    MAP: `${eos}setting/star-map`,
    CONCLAVE: `${eos}conclave`,

    SL_CUSTOMS: `${eos}admin_sl/characters.php`,
    SL_TALON: `${ht}talon${s_eos}sl_admin`,
    SL_MEDICORUM: `${eos}medicorum/admin-exclude.php`,
    SL_BEACON: `${ht}beacon${s_eos}adm/`,
    SL_CIC: `${ht}cic${s_eos}#/admin`,
    SL_NAMEGEN: `${ht}persona${s_eos}`,
    SL_MAP: `${eos}setting/star-map/star-map-admin`,
    SL_SPACEBOOK: `${eos}sl-menu/spacebook`,
    SL_AV: `${ht}av${s_eos}admin`,
    SL_SCB: `${eos}admin_sl/transfer.php`,
  },
}
